import { useDeleteApiAccountKeyMutation } from "@sso/apis/apiAccountKeys";
import { DialogTitle } from "@sso/constant";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectDialog } from "@sso/store/slices/dialog";
import { Typography } from "@sso/ui/Typography";

import { DialogActionButtons, DialogBody, DialogHeader } from "../components";


export const DeleteApiAccountKeyDialog = () => {
    const { id } = useAppSelector(selectDialog);

    const [deleteKey] = useDeleteApiAccountKeyMutation();

    const handleDeleteAction = () => { deleteKey(id as string); };

    return (
        <>
            <DialogHeader title={DialogTitle.DELETE_API_ACCOUNT_KEY} />
            <DialogBody>
                <Typography display="initial">
                    Are you sure to delete this API Account Key?
                </Typography>
            </DialogBody>
            <DialogActionButtons buttonTitle={"Delete"} onClickAction={handleDeleteAction} />
        </>
    );
};
